import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, App, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { NotiDetailsPage } from '../pages/notidetails/notidetails';
import { HomePage } from '../pages/home/home';
import { HkApiproviderProvider } from '../providers/hk-apiprovider/hk-apiprovider';
import { OneSignal, OSNotificationPayload } from '@ionic-native/onesignal';
import { Deeplinks } from '@ionic-native/deeplinks'
declare var window;
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  validEmail:any;
  rootPage: string = "HomePage";
  isLogin: boolean = false;
  loginuser:any;
  role:any;
  pages: Array<{title: string, component: any}>;

  apptoken = {"token":""};
  postData = {
    user_id:"",
    oneSignal_userId:"",
    oneSignal_pushToken:""
  };
  resposeData : any;
  allMessage:any;
  userDetails:any;
  creater_name:any;
  create_company:any;
  constructor( public platform: Platform,
              public app:App,
              public statusBar: StatusBar,
              public splashScreen: SplashScreen,
              public oneSignal:OneSignal,
              public authService: HkApiproviderProvider,
              public events: Events,
              private deeplinks: Deeplinks) {
    this.initializeApp();
    window.component = this;
    this.creater_name = "";
    this.events.subscribe('user:signedIn', (userEventData,time) => {
      const data = JSON.parse(localStorage.getItem('userData'));
      this.loginuser = data.userData.user_id;
      this.role = data.userData.role;
      this.isLogin = true;
      this.initializeApp();
     });

    this.apptoken.token = HkApiproviderProvider.gettoken();
    localStorage.setItem('appconfig', JSON.stringify(this.apptoken));
	if(localStorage.getItem('userData')){
		const data = JSON.parse(localStorage.getItem('userData'));
		this.loginuser = data.userData.user_id;
    this.role = data.userData.role;
    this.creater_name = data.userData.creater_name;
    this.create_company = data.userData.create_company;
    this.isLogin = true;
	}
  }

  initializeApp() {
    this.authService.getLocation();
    this.platform.ready().then(() => {
      if(this.platform.is('android')){
        HomePage.userPlatform = 'android';
      } 
      if(this.platform.is('ios')){
        HomePage.userPlatform = 'ios';
      } 
      if(this.isCordovaAvailable){
        this.oneSignal.startInit('3380ed8f-a2fd-496b-8ff5-1dffc80a254c', '315926987778');
        this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.Notification);
        this.oneSignal.handleNotificationReceived().subscribe(data => this.onPushReceived(data.payload));
        this.oneSignal.handleNotificationOpened().subscribe(data => this.onPushOpened(data.notification.payload));
        if(this.isLogin){
          this.oneSignal.getIds().then(identity => {
          this.oneSignalUpdate(identity.userId,identity.pushToken);
          });
        }
        this.oneSignal.endInit();
         this.statusBar.backgroundColorByHexString('#307722');
         this.splashScreen.hide();
      }
      this.deeplinks.routeWithNavController(this.nav, {
        '/home': HomePage,
        '/notification/:noti_id': NotiDetailsPage,
      }).subscribe((match) => {
        console.log('Successfully routed', match);
      }, (nomatch) => {
        console.warn('Unmatched Route', nomatch);
      });
    });
  }

  oneSignalUpdate(userId:string,pushToken:string){
    this.postData.oneSignal_userId = userId;
    this.postData.oneSignal_pushToken = pushToken;
    this.postData.user_id = this.loginuser;
    this.authService.postData(this.postData, "oneSignalUpdate").then((result) =>{
			this.resposeData = result;
      if (this.resposeData.success) {
        console.log("Success");
      } else {
        console.log("Error");
      }
		}, (err) => {
		});
  }

  onPushReceived(payload: OSNotificationPayload) {  
    if(this.isCordovaAvailable){
      if(payload.additionalData.noti_type =='notification'){
        this.nav.setRoot("NotiDetailsPage",{id:payload.additionalData.id});
      }
    }
  }  
  
  onPushOpened(payload: OSNotificationPayload) {  
    if(this.isCordovaAvailable){
      if(payload.additionalData.noti_type =='notification'){
        this.nav.setRoot("NotiDetailsPage",{id:payload.additionalData.id});
      }
    }
  }  

  isCordovaAvailable = () => {  
    if (!(<any>window).cordova) {  
        alert('This is a native feature. Please use a device');  
        return false;  
    }  
    return true;  
  };   

  changeLanguage(){
    this.nav.setRoot("IntroPage");
  }
  onclickHome(){
    this.nav.setRoot("HomePage");
  }

  onclickMyProfile(){
	this.nav.setRoot("MyProfilePage");
  }

  openfeedback(){
    this.nav.setRoot("FeedbackPage");
  }
  openoffers(){
    this.nav.setRoot("OfferShopListPage");
  }

  checkLogin(){
    if(localStorage.getItem('userData')){
      return true;
    }else{
      return false;
    }
  }

  onclickCriminalRecord(){
    this.nav.setRoot("CriminalRecordPage");
  }

  onclickDeadRecord(){
    this.nav.setRoot("CaseRecordPage");
  }

  onclickCovidRecord(){
    this.nav.setRoot("CovidRecordPage");
  }

  onclickNotification(){
    this.nav.setRoot("NotificationsPage");
  }
  
  logout(){
  	localStorage.removeItem('userData');
  	this.isLogin = false;
  	window.location.reload();
    this.nav.setRoot("HomePage");
  }
  login(){
    this.nav.setRoot("LoginPage");
  }
  onclickAcceptedList(){
    this.nav.setRoot("AcceptedUserListPage");
  }
  onclickDonorList(){
    this.nav.setRoot("DonorListPage");
  }
  onclickDonateList(){
    this.nav.setRoot("DonatedListPage");
  }
  onclickAccounting(){
    this.nav.setRoot("AccountingPage");
  }
  onclickORGSAccounting(){
    this.nav.setRoot("ORGSAccountingPage");
  }
  onclickManageAdmin(){
    this.nav.setRoot("ManageAdminPage");
  }
  onclickCurrentSurplus(){
    this.nav.setRoot("CurrentSurplusPage");
  }
  onclickSoldierManagement(){
    this.nav.setRoot("SoldierManagementPage");
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts